"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _DateCell = _interopRequireDefault(require("../DateCell"));

var _makeCalendarRows = _interopRequireDefault(require("./makeCalendarRows"));

var _withStyles = _interopRequireDefault(require("../../../utils/withStyles"));

var _isInMinMaxBounds = _interopRequireDefault(require("../utils/isInMinMaxBounds"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

var CalendarTable = function CalendarTable(_ref) {
  var classes = _ref.classes,
      viewDate = _ref.viewDate,
      nonRangeSelectedDate = _ref.nonRangeSelectedDate,
      rangedStartDate = _ref.rangedStartDate,
      rangedEndDate = _ref.rangedEndDate,
      selectDate = _ref.selectDate,
      viewMonthOnly = _ref.viewMonthOnly,
      min = _ref.min,
      max = _ref.max,
      props = _objectWithoutProperties(_ref, ["classes", "viewDate", "nonRangeSelectedDate", "rangedStartDate", "rangedEndDate", "selectDate", "viewMonthOnly", "min", "max"]);

  var now = (0, _moment["default"])();
  var viewMonth = viewDate.month();
  var dateToUseForTime = nonRangeSelectedDate || viewDate;
  var selectedHour = dateToUseForTime.hour();
  var selectedMinute = dateToUseForTime.minute();
  var rows = (0, _makeCalendarRows["default"])(viewDate);
  return _react["default"].createElement("table", _extends({
    className: classes.root
  }, props), _react["default"].createElement("tbody", null, _react["default"].createElement("tr", null, WEEKDAYS.map(function (day) {
    return _react["default"].createElement("th", {
      key: day,
      className: classes.headerCell
    }, day);
  })), rows.map(function (row, rowIdx) {
    return _react["default"].createElement("tr", {
      key: rowIdx
    }, row.map(function (_ref2, colIdx) {
      var year = _ref2.year,
          month = _ref2.month,
          dayOfMonth = _ref2.dayOfMonth;
      var date = (0, _moment["default"])().year(year).month(month).date(dayOfMonth).hour(selectedHour).minute(selectedMinute);
      var isSingleSelectedDate = date.isSame(nonRangeSelectedDate, 'date');
      var isStartDate = date.isSame(rangedStartDate, 'date');
      var isEndDate = date.isSame(rangedEndDate, 'date');
      var isInViewMonth = month === viewMonth;
      var dateCellProps = {
        date: date,
        selectDate: selectDate,
        isCurrentDate: date.isSame(now, 'date'),
        isSelected: isSingleSelectedDate || isStartDate || isEndDate,
        isInRange: date.isBetween(rangedStartDate, rangedEndDate),
        isInViewMonth: isInViewMonth,
        isEmpty: !isInViewMonth && viewMonthOnly,
        isDisabled: !(0, _isInMinMaxBounds["default"])(date, min, max)
      };
      return _react["default"].createElement(_DateCell["default"], _extends({
        key: colIdx
      }, dateCellProps));
    }));
  })));
};

CalendarTable.propTypes = {
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  viewDate: _propTypes["default"].shape().isRequired,
  nonRangeSelectedDate: _propTypes["default"].shape(),
  rangedStartDate: _propTypes["default"].shape(),
  rangedEndDate: _propTypes["default"].shape(),
  selectDate: _propTypes["default"].func.isRequired,
  viewMonthOnly: _propTypes["default"].bool,
  // Determines if dates from prev/next month are displayed
  min: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]),
  max: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)])
};
CalendarTable.defaultProps = {
  nonRangeSelectedDate: null,
  rangedStartDate: null,
  rangedEndDate: null,
  viewMonthOnly: false,
  min: '',
  max: ''
};

var _default = (0, _withStyles["default"])(_styles["default"])(CalendarTable);

exports["default"] = _default;